import "../components/FeatureSection.css";

export default function FeatureSection() {
  const features = [
    {
      title: "Clinical Excellence",
      description: "Rigorous clinical trials and FDA approvals ensure safety and efficacy.",
      image: "/clinical-trials-medical-research-diverse-team-of-h.jpg",
    },
    {
      title: "Research-Driven",
      description: "Cutting-edge research backing every product development.",
      image: "/pharmaceutical-scientist-in-lab-coat-medical-innov.jpg",
    },
    {
      title: "Patient Care",
      description: "Committed to improving patient outcomes and quality of life.",
      image: "/patient-care-medical-consultation-doctor-patient-h.jpg",
    },
  ]

  return (
    <section className="feature-section">
      <div className="feature-container">
        <h2 className="feature-heading">Why Choose Natoshine</h2>

        <div className="feature-grid">
          {features.map((feature, i) => (
            <div key={i} className="feature-card">
              <div className="feature-image-wrapper">
                <img
                  src={feature.image || "/placeholder.svg"}
                  alt={feature.title}
                  className="feature-image"
                />
              </div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

